var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#34C759"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.983 5.75166C14.3733 5.99558 14.492 6.50971 14.248 6.89999L9.56053 14.4C9.41819 14.6277 9.17482 14.7729 8.9068 14.79C8.63878 14.807 8.37897 14.6939 8.2089 14.486L5.3964 11.0485C5.10496 10.6923 5.15746 10.1673 5.51367 9.87586C5.86987 9.58442 6.39489 9.63692 6.68633 9.99312L8.76304 12.5313L12.8347 6.01666C13.0786 5.62638 13.5928 5.50773 13.983 5.75166Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneGreen);
export default __webpack_public_path__ + "static/media/doneGreen.4aa55ae01b5e63db7dcb810e7c911bd3.svg";
export { ForwardRef as ReactComponent };